import {observer} from "mobx-react";
import {vhsDetailStore, VhsLabelPrintDialogStore} from "../../../store";
import {convertDocumentType, mapDocumentTypeStatus} from "../../../api";
import {vhsPrinterStore} from "../../../store/vhs/VhsPrinterStore";
import {Linq, ScrollTable} from "../../ui";

interface DetailIntroProps {
    printDialogStore: VhsLabelPrintDialogStore
}

const DetailIntro = observer(function DetailIntro({
                                                      printDialogStore
                                                  }: DetailIntroProps) {
    const data = vhsDetailStore.overviewData
    const documentCount = data?.documents.length || 0
    const tableHeight = documentCount < 3 ? 7 : Math.min(18, documentCount * 2.3)
    return <div
        style={{
            padding: '1em',
            display: 'flex',
            borderBottom: '1px dashed black'
        }}
    >
        <div
            style={{
                flex: '1'
            }}
        >
            {data?.customer?.customerId && <div style={{marginBottom: '1em'}} className={"has-text-primary label"}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Kunde</label>
                <Linq
                    to={`/cms/${data?.customer?.customerId}`}>{data?.customer?.displayName} ({data?.customer?.customerNumber})</Linq>
            </div>}
            <div style={{marginBottom: '1em'}} className={"has-text-primary label"}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>FIN</label>
                <div>{data?.vin}</div>
            </div>
            {data?.trackingLink && <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Sendungsverfolgung</label>
                <div>{data?.trackingLink}</div>
            </div>}
        </div>
        <div
            style={{
                flex: '1'
            }}
        >
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0', position: 'relative'}}>
                    <span>Dokumente</span>&nbsp;
                    {documentCount && <span
                        className="tag is-dark is-rounded"
                        style={{
                            position: 'relative',
                            top: '-0.5em',
                            left: '0.5em'
                        }}
                    >{documentCount}</span>}
                </label>
                <div style={{
                    display: 'flex',
                    height: `${tableHeight}em`
                }}>

                    <ScrollTable>
                        <tbody>
                        {data?.documents.map(e => (
                            <tr key={e.documentId}>
                                <td>{convertDocumentType(e.type)}</td>
                                <td>
                                    <span className="tag is-light is-rounded has-text-primary" style={{
                                        marginLeft: '1em',
                                        marginRight: '1em'
                                    }}>{mapDocumentTypeStatus(e.status)}</span>
                                </td>
                                <td>{e.location}</td>
                                <td style={{width: '4em'}}>
                                    <button
                                        style={{
                                            padding: '0.2em 0.7em'
                                        }}
                                        title={"Label drucken"}
                                        className={"button is-small is-rounded is-info"}><span
                                        style={{
                                            zoom: '0.8'
                                        }}
                                        className="material-symbols-outlined"
                                        onClick={async () => {
                                            await vhsPrinterStore.load()
                                            printDialogStore.document = {
                                                customerId: data?.customer?.customerId!,
                                                documentId: e.documentId,
                                                vin: data?.vin,
                                                location: e.location,
                                                type: e.type,

                                            }
                                            printDialogStore.dialogOpen = true
                                        }}
                                    >print</span></button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </ScrollTable>
                </div>
            </div>
        </div>
    </div>
})

export {
    DetailIntro
}
